/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    angular
        .module('enervee.fastTrack')
        .directive('fastTrackButton', fastTrackButton);

    function fastTrackButton() {
        return {
            restrict: 'E',
            scope: {
                btnClass: '@'
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: FastTrackButtonController,
            template: require('@app/components/fastTrack/fastTrackButtonView.html')
        };

    }

    FastTrackButtonController.$inject = [
        '$state',
        '$window',
        'AnalyticsService',
        'CmsContentService',
        'UtilService',
        'FastTrackModalService',
        'ModalQueueService'
    ];

    function FastTrackButtonController(
        $state,
        $window,
        AnalyticsService,
        CmsContentService,
        UtilService,
        FastTrackModalService,
        ModalQueueService
    ) {
        this.$onInit = function () {
            var vm = this;

            var fastTrackUrl = UtilService.getSiteSetting('rebate_fast_track_url');
            vm.goToFastTrack = goToFastTrack;
            CmsContentService.retrieveCMSValue(vm, 'fastTrackPopoverTitle', 'base:header:rebate_fast_track_alert_title');
            CmsContentService.retrieveCMSValue(vm, 'fastTrackPopoverText', 'base:header:rebate_fast_track_alert_text');

            vm.fastTrackPopover = {
                isEnabled: true,
                isOpen: false,
                template: require('@app/shared/popovers/fastTrackPopover.html'),
                openPopover: function () {
                    vm.isOpen = true;
                },
                closePopover: function () {
                    vm.isOpen = false;
                }
            };


            /**
             * Handles the fast track button click. If the instant rebate url is set,
             * we open that url in a new tab. Otherwise, open the first modal in the
             * fast track process.
             */
            function goToFastTrack() {
                ModalQueueService.closePastModals(this.closePopover);

                if (!fastTrackUrl) {
                    // check which fast track to show
                    if (UtilService.isFeatureEnabled('fast_track_with_rrapi')) {
                        FastTrackModalService.showFastTrackModal('header');
                    } else {
                        $state.go('rebate-fast-track');
                    }
                } else {
                    $window.open(
                        fastTrackUrl,
                        '_blank'
                    );
                }
                AnalyticsService.reportEvent('Fast Track Header Button Clicked');
            }
        };

    }
})(angular);